import axios from 'axios';

export default axios.create({
    baseURL : ( process.env.NODE_ENV === 'production' ? 'https://kurse.bimm.at/api/v1' : 'http://bimm-education.loc:8888/api/v1' )
});